import {
  Option,
  booleanOptions,
  tipoSerieOptions,
  negociacaoSecundariaOptions,
  depositariaEmissaoOptions,
  naturezaPessoaOptions,
  tipoDistribuicaoPublicaOptions,
  unidadeFederativaOptions,
  tipoLiquidacaoOptions,
  contraparteRecebedoraOptions,
  tiposFundoOptions,
} from 'common/genericOptions';
import { typedAction } from 'store/modules/base';
import { EmissaoStatus, InvestidorResponse } from 'common/genericTypes';
import { Moment } from 'moment';


export interface CaracteristicasState {

  cnpjFundo: string;
  numeroEmissao: string;
  administradorFiduciarioId: string;
  nomeFantasia: string;
  gestor: string;
  escrituradorId: string;
  custodianteId: string;
  codigoAtivo: string;
  classe: string;
  serie: string;
  isin: string;
  classificacaoANBIMA: string;
  codigoANBIMA: string;
  numeroAutorizacaoCVM: number;
  dataAutorizacaoCVM?: Moment;
  

  fundoExclusivo: boolean;
  carencia: number;
  tipoFundo: string;
  casasDecimaisConversao: number;
  criterioEspecificacaoCotas: string
  especificacaoQuantidadeAutomatica: boolean
  custoCotista: string;
  confirmacaoOperacao: string;
  

  prazoCotacaoAplicacao: number;
  prazoCotacaoResgate: number;
  prazoLiquidacaoResgate: number;
  responsavelClassificacaoFundo: string;
  temPrevisaoPenalty: boolean;
  percentualPenalty: number;
  descricaoFundo: string;

  
  escriturador?: string;
  custodiante?: string;
  administradorFiduciario?: string;
  dataAutorizacaoCVMUI?: Moment
  fundoExclusivoUI?: Option;
  tipoFundoUI?: Option;
  especificacaoQuantidadeAutomaticaUI?: Option
  custoCotistaUI?: Option;
  confirmacaoOperacaoUI?: Option;
  temPrevisaoPenaltyUI?: Option;
}

export const caracteristicasInitialState: CaracteristicasState = {
  cnpjFundo: '',
  numeroEmissao: '',
  administradorFiduciarioId: '',
  nomeFantasia: '',
  gestor: '',
  escrituradorId: '',
  custodianteId: '',
  codigoAtivo: '',
  classe: '',
  serie: '',
  isin: '',
  classificacaoANBIMA: '',
  codigoANBIMA: '',
  numeroAutorizacaoCVM: undefined as unknown as number,
  dataAutorizacaoCVM: undefined,
  
  fundoExclusivo: undefined as unknown as boolean,
  carencia: undefined as unknown as number,
  tipoFundo: '',
  casasDecimaisConversao: undefined as unknown as number,
  criterioEspecificacaoCotas: '',
  especificacaoQuantidadeAutomatica: undefined as unknown as boolean,
  custoCotista: '',
  confirmacaoOperacao: '',
  
  prazoCotacaoAplicacao: undefined as unknown as number,
  prazoCotacaoResgate: undefined as unknown as number,
  prazoLiquidacaoResgate: undefined as unknown as number,
  responsavelClassificacaoFundo: '',
  temPrevisaoPenalty: undefined as unknown as boolean,
  percentualPenalty: undefined as unknown as number,
  descricaoFundo: '',


  escriturador: '',
  custodiante: '',
  administradorFiduciario: '',
  dataAutorizacaoCVMUI: undefined,
  fundoExclusivoUI: undefined,
  tipoFundoUI: undefined,
  especificacaoQuantidadeAutomaticaUI: undefined,
  custoCotistaUI: undefined,
  confirmacaoOperacaoUI: undefined,
  temPrevisaoPenaltyUI: undefined,
};

export interface MetadataState {
  series: Array<Option>;
  negociacoesSecundarias: Array<Option>;
  options: Array<Option>;
  depositariaEmissoes: Array<Option>;
  tipoDistribuicaoPublica: Array<Option>;
  contraparteRecebedora: Array<Option>;
  naturezaPessoa: Array<Option>;
  unidadesFederativas: Array<Option>;
  tiposFundo: Array<Option>;
  tiposLiquidacao: Array<Option>;
  investidores: Array<InvestidorResponse>;
}

export const metadataInitialState: MetadataState = {
  series: tipoSerieOptions,
  negociacoesSecundarias: negociacaoSecundariaOptions,
  options: booleanOptions,
  depositariaEmissoes: depositariaEmissaoOptions,
  tipoDistribuicaoPublica: tipoDistribuicaoPublicaOptions,
  contraparteRecebedora: contraparteRecebedoraOptions,
  naturezaPessoa: naturezaPessoaOptions,
  unidadesFederativas: unidadeFederativaOptions,
  tiposFundo: tiposFundoOptions,
  tiposLiquidacao: tipoLiquidacaoOptions,
  investidores: [],
};

export interface FundoField {
  name: keyof CaracteristicasState;
  value: string | number | boolean | null | Moment | Option;
}

interface Field {
  name: keyof CaracteristicasState;
  value: number
  | string
  | boolean
  | undefined | null | Moment | Option | Array<string>;
}

interface MetadataField {
  name: keyof MetadataState;
  value: Array<Option> | Array<InvestidorResponse>;
}

export const updateField = (field: Field) => {
  return typedAction('cotasDeFundo/caracteristicas/UPDATEFIELD', field);
};

export const updateMetadata = (field: MetadataField) => {
  return typedAction('cotasDeFundo/metadata/UPDATEFIELD', field);
};

export const resetMetadata = () => {
  return typedAction('cotasDeFundo/metadata/RESET');
};

export const resetCotasDeFundoDetails = () => {
  return typedAction('cotasDeFundo/caracteristicas/RESET');
};

export const updateCotasDeFundoCaracteristicas = (state: CaracteristicasState) => {
  return typedAction('cotasDeFundo/caracteristicas/UPDATE', state);
};

export type CaracteristicasAction = ReturnType<
  | typeof updateField
  | typeof resetCotasDeFundoDetails
  | typeof updateMetadata
  | typeof updateCotasDeFundoCaracteristicas
  | typeof resetMetadata
>;
